export default __webpack_public_path__ + "static/media/widget.ee24c24d.svg";